import {Link} from 'react-router-dom';
import {WithChildren} from '../../../../common/helpers';

interface Props {
	to?: string;
	onClick?: () => void;
}

export default function SecondaryLink({to, onClick, children}: Props & WithChildren) {
	const btnClass =
		'w-full p-2.5 lg:p-3.5 border border-primary bg-primary/10 rounded-4xl text-primary text-base md:text-xs lg:text-sm font-medium text-center h-12  md:pt-[15px]';
	return (
		<div className='w-full flex'>
			{to && (
				<Link className={btnClass} to={to}>
					{children}
				</Link>
			)}
			{onClick && (
				<button className={btnClass} onClick={onClick}>
					{children}
				</button>
			)}
		</div>
	);
}
